Vue.component('tripadvisor-lookup', {
  props: ['tripadvisorUrlElementId', 'hotelNameElementId', 'placeholder', 'hideResults', 'disabled'],

  template: `
  <div class="autocomplete-container ais-copycat">
    <div class="ais-SearchBox">
      <div class="form-icon" v-if="!searchQuery.length">
        <i class="fas fa-search"></i>
      </div>

      <input :disabled="disabled" type="text" :placeholder="placeholder || ''"  
        v-model="searchQuery" v-on:keyup="autoComplete" class="has-icon form-control"
      >
    </div>
    <small v-if="!hideResults">
      <a :href="selectedResult.url" v-if="selectedResult" target="_blank" class="btn btn-link btn-small">
        Visit page of <br> [{{selectedResult.name}} in {{selectedResult.area}}]
      </a> 
    </small>
    <div class="ais-StateResults" v-if="dataResults.length">
      <div class="alg-hits">
        <div class="ais-Hits">
          <ul class="ais-Hits-list">
            <li class="ais-Hits-item" v-for="result in dataResults" v-on:click="fillInUrl(result)">
              <div>
                <h2>{{ result.name }}</h2>
                <p class="subtitle">{{ result.area }} ({{result.number_of_reviews}} reviews)</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>`,

  data: function () {
    return {
      searchQuery: '',
      dataResults: [],
      selectedResult: null
    }
  },
  methods: {
    autoComplete() {
      this.dataResults = []
      this.selectedResult = null

      if (this.searchQuery.length > 2) {
        params = { lookFor: encodeURI(this.searchQuery) }
        axios.get('/api/lookups/taFullTextSearch',{ params: params })
        .then(response => {
          // console.log(response)
          this.dataResults = response.data
        })
      }

    },
    fillInUrl: function(aResult) {
      // console.log('Fill in ' + this.$props.tripadvisorUrlElementId + ' value:' + aResult.url)

      if ( this.$props.tripadvisorUrlElementId ) {
        // Assume that parent is just a simple form/element and NOT a VueJS managed element
        document.getElementById('tripadvisor-link').value = aResult.url
        nameElement = document.getElementById(this.$props.hotelNameElementId)
        if ( nameElement ) {
          nameElement.value = aResult.name
        }
      }
      else {
        // VueJS managed element(s)
        this.$emit('selected', aResult)
        this.$emit('input', aResult)
      }

      // TODO: use property 'tripadvisorUrlElementId' ?
      this.selectedResult = aResult
      this.dataResults = []
    }
  }
})